<template>
  <b-card>
    <base-overlay :show="fetching">
      <test-version
        :version-settings="pricing.settings"
        :current-zones="isNew ? pricing.zone : [pricing.zone]"
      />
      <drop-zones
        v-if="!fetchingZones"
        :selected-drop-zones="pricing.settings.drop_zones"
        :zones="zones"
        @drop-zones="pricing.settings.drop_zones = $event"
      />
      <peak-factors
        :selected-peak-factors="pricing.settings.peak_factors"
        @peak-factors="pricing.settings.peak_factors = $event"
      />
      <slicings
        :slicings="pricing.settings.time_slicings"
        @time-slices="pricing.settings.time_slicings = $event"
      />
      <slicings
        slices-type="distance"
        :slicings="pricing.settings.distance_slicings"
        @distance-slices="pricing.settings.distance_slicings = $event"
      />
      <b-row>
        <b-col md="4">
          <b-form-group
            label="Group"
            label-for="groups"
          >
            <v-select
              id="groups"
              v-model="pricing.group"
              :options="groupsList"
              label="name"
              :reduce="val => val.id"
              @search="fetchGroups"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="Zones"
            label-for="zones"
          >
            <v-select
              id="zones"
              v-model="pricing.zone"
              :options="formZonesOptions"
              label="name"
              :reduce="zone => zone.zone_id"
              :multiple="isNew"
              @input="zoneInputHandler"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="Services"
            label-for="service"
          >
            <v-select
              id="service"
              v-model="pricing.service_class"
              :options="formServicesOptions"
              label="id"
              :reduce="val => val.id"
              :multiple="isNew"
              @input="serviceInputHandler"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group
            label="General Section"
          />
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Label"
            label-for="pricing-name"
          >
            <b-form-input
              id="pricing-name"
              v-model="pricing.label"
            />
          </b-form-group>
          <b-form-group
            label="Minmum Amount"
            label-for="minimum-amount"
          >
            <b-form-input
              id="minimum-amount"
              v-model.number="pricing.settings.minimum_amount"
              type="number"
            />

          </b-form-group>
          <b-form-group
            label="Admin Commission"
            label-for="admin-commission"
          >
            <b-form-input
              id="admin-commission"
              v-model.number="pricing.settings.admin_commission"
              type="number"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Priority"
            label-for="form-priority"
          >
            <b-form-input
              id="form-priority"
              v-model.number="pricing.priority"
              type="number"
            />

          </b-form-group>
          <b-form-group
            label="Open Meter Amount"
            label-for="open-meter-amount"
          >
            <b-form-input
              id="open-meter-amount"
              v-model.number="pricing.settings.open_meter_amount"
              type="number"
            />
          </b-form-group>
          <b-form-group
            label="Tax Amount"
            label-for="tax-amount"
          >
            <b-form-input
              id="tax-amount"
              v-model.number="pricing.settings.tax_amount"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Effective Date Time"
            label-for="effective-time"
          >
            <flat-pickr
              v-model="pricing.effective_date_time"
              class="form-control"
              :config="{ enableTime: true}"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Estimates Price Section" />
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Rate"
            label-for="estimates-rate"
          >
            <b-form-radio-group
              id="estimates-rate"
              v-model="pricing.settings.estimates.rate"
              :options="rateOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Rate Value"
            label-for="rate-value"
          >
            <b-form-input
              id="rate-value"
              v-model.number="pricing.settings.estimates.value"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Arrival Section" />
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Amount Per minute"
            label-for="arrival-amount-per-minute"
          >
            <b-form-input
              id="arrival-amount-per-minute"
              v-model.number="pricing.settings.arrival.amount_per_minute"
              type="number"
            />
          </b-form-group>

        </b-col>
        <b-col md="6">
          <b-form-group

            label="Free Waiting Time"
            label-for="arrival-free-waiting-time"
          >
            <b-form-input
              id="arrival-free-waiting-time"
              v-model.number="pricing.settings.arrival.free_waiting_time"
              type="number"
            />
          </b-form-group>

        </b-col>
        <!--  -->
        <b-col md="6">
          <b-form-group

            label="Maximum Time threshold"
            label-for="arrival-max-time-threshold"
          >
            <b-form-input
              id="arrival-max-time-threshold"
              v-model.number="pricing.settings.arrival.maximum_time_threshold"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <card-collapse
            border-variant="primary"
          >
            <template #card-title>
              <div class="d-flex">
                <h3 class="mr-2">
                  Upfront Estimates
                </h3>
                <b-form-checkbox
                  v-model="pricing.settings.upfront_estimates.active"
                  switch
                >
                  Active
                </b-form-checkbox>
              </div>
            </template>
            <b-row>
              <b-col md="5">
                <h4>Distance</h4>
                <b-form-group
                  label="Minimum Distance Threshold"
                  label-for="minimum-distance-threshold"
                >
                  <b-form-input
                    id="minimum-distance-threshold"
                    v-model.number="pricing.settings.upfront_estimates.minimum_distance_threshold"
                    type="number"
                  />

                </b-form-group>
                <b-form-group
                  label="Rate"
                  label-for="upfront-estimates-rate"
                >
                  <b-form-radio-group
                    id="upfront-estimates-rate"
                    v-model="pricing.settings.upfront_estimates.distance.rate"
                    :options="rateOptions"
                  />
                </b-form-group>

                <b-form-group
                  :label="`Minimum ${distanceLabeling}`"
                  label-for="minimum-upfront-distance"
                >
                  <b-form-input
                    id="minimum-upfront-distance"
                    v-model.number="pricing.settings.upfront_estimates.distance.minimum"
                    type="number"
                  />
                </b-form-group>
                <b-form-group
                  :label="`Maximum ${distanceLabeling}`"
                  label-for="maximum-upfront-distance"
                >
                  <b-form-input
                    id="maximum-upfront-distance"
                    v-model.number="pricing.settings.upfront_estimates.distance.maximum"
                    type="number"
                  />

                </b-form-group>
              </b-col>
              <hr>
              <b-col
                md="2"
                class="d-flex justify-content-center"
              >
                <div class="vertical-line" />
              </b-col>
              <b-col md="5">
                <h4>Time</h4>
                <!-- Dummy div to inline inputs with each other -->
                <div style="height:75px" />
                <b-form-group
                  label="Rate"
                  label-for="upfront-estimates-rate-time"
                >
                  <b-form-radio-group
                    id="upfront-estimates-rate-time"
                    v-model="pricing.settings.upfront_estimates.time.rate"
                    :options="rateOptions"
                  />
                </b-form-group>
                <b-form-group
                  :label="`Minimum ${timeLabeling}`"
                  label-for="minimum-upfront-time"
                >
                  <b-form-input
                    id="minimum-upfront-time"
                    v-model.number="pricing.settings.upfront_estimates.time.minimum"
                    type="number"
                  />

                </b-form-group>
                <b-form-group
                  :label="`Maximum ${timeLabeling}`"
                  label-for="maximum-upfront-time"
                >
                  <b-form-input
                    id="maximum-upfront-time"
                    v-model.number="pricing.settings.upfront_estimates.time.maximum"
                    type="number"
                  />

                </b-form-group>
              </b-col>
            </b-row>
          </card-collapse>
        </b-col>
        <b-col md="2">
          <b-button
            v-b-modal.create-peak-factors
            variant="success"
          >
            Peak Factors
          </b-button>
        </b-col>
        <b-col md="2">
          <b-button
            v-b-modal.create-distance-slices
            variant="success"
          >
            Distance Slices
          </b-button>
        </b-col>
        <b-col md="2">
          <b-button
            v-b-modal.add-drop-zones
            variant="success"
          >
            Drop Zones
          </b-button>
        </b-col>
        <b-col md="2">
          <b-button
            v-b-modal.create-time-slices
            variant="success"
          >
            Time Slices
          </b-button>
        </b-col>
        <b-col
          md="12"
          class="d-flex justify-content-between mt-2"
        >
          <b-button
            v-b-modal.test-version
            variant="info"
          >
            Test Pricing
          </b-button>
        </b-col>
        <b-col
          md="12"
          class="d-flex justify-content-end"
        >
          <b-button
            :disabled="submitting"
            variant="success"
            @click="submitHandler"
          >
            submit
          </b-button>
        </b-col>
      </b-row>
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BFormGroup, BRow, BCol, BButton, BFormInput, BFormRadioGroup, BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import usePricingOverrideForm from '../hooks/usePricingOverrideForm'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'
import servicesStore from '@/views/services/serviceStoreModule'
import Slicings from './Slicings.vue'
import PeakFactors from '@/views/billing/versions/components/version-form/PeakFactors.vue'
import TestVersion from './TestVersion.vue'
import DropZones from './DropZones.vue'
import CardCollapse from '@/UI/CardCollapse.vue'
import groupsStore from '@/views/marketing/groups/store'
import pricingOverridesStore from '../store'

export default {
  components: {
    BCard, vSelect, BFormGroup, BRow, BCol, Slicings, PeakFactors, TestVersion, DropZones, BButton, BFormInput, flatPickr, CardCollapse, BFormRadioGroup, BFormCheckbox,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('pricing-override', pricingOverridesStore)
    useRegisterStoreModule('zones', zonesStore)
    useRegisterStoreModule('services', servicesStore)
    useRegisterStoreModule('groups', groupsStore)
    return {
      ...usePricingOverrideForm(ctx, props),
    }
  },
}
</script>

  <style>

  </style>
